export const defaultOptions: any = {
    //responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: true,
      },
    },
    scales: {
      y: {
        alignToPixels: true,
        stacked: true,
        grid: {
          display: true,
          drawBorder: false,
          drawOnChartArea: true,
          drawTicks: false,
        },
  
      },

      x: {
        type: 'time',
        stacked: true,
        time: {
          unit: 'month',
          stepSize: 1,
        },
        ticks: {
          display: true,
          autoSkip: true,
          maxRotation: 0
        },
        grid: {
          display: false,
          drawBorder: false,
          drawOnChartArea: false,
          drawTicks: false,
        }
      }
    }
  
  };


  export const defaultDataSet = {
    borderWidth: 1,
    borderColor: '#00000000',
    fill: true,
    barThickness: 9,
    borderRadius: 3,
  }